/**
 * cart-integration.js
 * This file demonstrates how to integrate the ShopifyCartDrawer module
 * with your existing theme and buybox solution
 */

// Initialize the cart drawer when the DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  // Create the cart drawer instance with custom options
  window.cartDrawer = new ShopifyCartDrawer({
    // Optional custom settings
    cartUpdateTimeout: 500, // Debounce time for quantity updates (ms)
    
    // You can override any of the default selectors here
    cartTriggerClass: 'cta-btn-cart', // Custom trigger class for your theme
    addToCartForms: 'form[action*="/cart/add"]' // Forms that should use AJAX submission
  });
  
  // Add custom event handlers for your specific theme needs
  
  // Handle the cart icon in the header
  const cartIcon = document.getElementById('cart-icon-bubble');
  
  // If the cart icon exists, modify its behavior
  if (cartIcon) {
    cartIcon.addEventListener('click', function(event) {
      // Prevent the default link behavior (navigating to /cart)
      event.preventDefault();
      
      // Open the cart drawer instead
      if (window.cartDrawer) {
        window.cartDrawer.openDrawer();
      } else {
        // Fallback in case the cart drawer isn't initialized
        console.warn('Cart drawer not initialized. Redirecting to cart page.');
        window.location.href = '/cart';
      }
    });
  }
  
  // Additionally, target all elements with the header__icon--cart class
  document.querySelectorAll('.header__icon--cart').forEach(icon => {
    if (icon !== cartIcon) { // Skip if it's the one we already handled
      icon.addEventListener('click', function(event) {
        event.preventDefault();
        
        if (window.cartDrawer) {
          window.cartDrawer.openDrawer();
        } else {
          window.location.href = '/cart';
        }
      });
    }
  });
  
  // Example: Register additional cart triggers dynamically
  document.querySelectorAll('.custom-cart-trigger').forEach(trigger => {
    trigger.addEventListener('click', function(e) {
      e.preventDefault();
      window.cartDrawer.openDrawer();
    });
  });
  
  // Example: Custom handling for special product forms
  document.querySelectorAll('.special-product-form').forEach(form => {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      
      // Get form data
      const formData = new FormData(form);
      
      // Add any additional properties needed
      formData.append('properties[_special_product]', 'true');
      
      // Use the cart drawer's addToCart method
      window.cartDrawer.addToCart(formData);
    });
  });
  
  // Example: Integration with direct add-to-cart links
  document.querySelectorAll('a[href*="/cart/add"]').forEach(link => {
    // The cart drawer already handles these, but you can add custom behavior
    link.addEventListener('click', function(e) {
      // Optional: Add analytics tracking here before the default handler takes over
      console.log('Direct add to cart link clicked:', link.href);
      
      // Let the drawer's built-in handler do the rest
    });
  });
  
  // Example: Listen for cart updates from other sources
  document.addEventListener('cart:updated', function(e) {
    // Refresh cart data when other scripts update the cart
    window.cartDrawer.fetchCartData();
  });
// --- Chat Widget: Hide when cart is open ---

  function setChatVisible(visible) {
    const chatWidget = document.querySelector('.woot--bubble-holder');
    if (chatWidget) chatWidget.style.display = visible ? '' : 'none';
  }

  // Clear stale sessionStorage on fresh page load
  const _drawerEl = document.getElementById('cart-drawer');
  if (!_drawerEl || _drawerEl.getAttribute('aria-hidden') !== 'false') {
    sessionStorage.removeItem('cartWasOpen');
  }

  // Patch openDrawer
  const _originalOpen = window.cartDrawer.openDrawer.bind(window.cartDrawer);
  window.cartDrawer.openDrawer = function() {
    sessionStorage.setItem('cartWasOpen', 'true');
    setChatVisible(false);
    _originalOpen();
  };

  // Patch closeDrawer (mobile)
  const _originalClose = window.cartDrawer.closeDrawer.bind(window.cartDrawer);
  window.cartDrawer.closeDrawer = function() {
    sessionStorage.removeItem('cartWasOpen');
    _originalClose();
    setChatVisible(true);
  };

  // Watch the drawer aria-hidden directly — fires on desktop close no matter what triggers it
  if (_drawerEl) {
    new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.attributeName === 'aria-hidden') {
          const isNowClosed = _drawerEl.getAttribute('aria-hidden') === 'true';
          if (isNowClosed) {
            sessionStorage.removeItem('cartWasOpen');
            setChatVisible(true);
          } else {
            sessionStorage.setItem('cartWasOpen', 'true');
            setChatVisible(false);
          }
        }
      });
    }).observe(_drawerEl, { attributes: true, attributeFilter: ['aria-hidden'] });
  }

  // Watch for Woot widget reappearing while cart is open (bfcache / dynamic reinit)
  new MutationObserver(function() {
    if (sessionStorage.getItem('cartWasOpen') === 'true') {
      const chatWidget = document.querySelector('.woot--bubble-holder');
      if (chatWidget && chatWidget.style.display !== 'none') {
        chatWidget.style.display = 'none';
      }
    }
  }).observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style', 'class']
  });

  // Handle back button from checkout (bfcache)
  window.addEventListener('pageshow', function(event) {
    if (event.persisted && sessionStorage.getItem('cartWasOpen') === 'true') {
      setChatVisible(false);
    }
  });

});